import React, { Component } from "react";
import { AnimateOnChange } from "react-animation";
import { connect } from 'react-redux';
import activitiesConfig from "../config/activities.json";
import AtividadeDia from "./AtividadeDia";

class DiaSemanaAgenda extends Component {

	state = {
		habilitado: false,
		dia: "",
		fatoFake: null,
		video: null,
		game: null,
		extra: null,
		diaTextual: null,
		novoHabito: null,
	};

	constructor(props) {
		super(props);
		let data = new Date(props.dia.day);
		if (props.evento && props.evento.startDate) {
			let dataInicio = props.evento.startDate.split("/")
			let horasInicio = dataInicio[2].split(" ")
			dataInicio[2] = horasInicio[0]
			horasInicio = horasInicio[1].split(":")
		}
		let dataTextual = props.dia.day.replace("00:00:00", "").replace(" ", "");
		let componentesData = dataTextual.split("-");
		dataTextual = componentesData[2] + "/" + componentesData[1];
		if (isNaN(data.getTime())) {
			data = new Date(props.dia.day.replace("-", "/").replace("-", "/"));
		}
		let diaExibir =
			(data.getDate() < 10 ? "0" + data.getDate() : data.getDate()) +
			"/" +
			(data.getMonth() < 10 ? "0" + data.getMonth() : data.getMonth());

		let enabled = props.diaEnabled

		let sortedActivities = this.sortActivities(
			props.dia.activities,
			enabled,
			dataTextual
		);
		for (let i = 0; i < sortedActivities.length; i++) {
			let element = sortedActivities[i];
			let primeiro = i === 0;
			let ultimo = i === sortedActivities.length - 1;
			let cssPrimeiro = primeiro ? " card-atividades__primeiro" : "";
			let cssUltimo = ultimo ? " card-atividades__ultimo" : "";
			let cssDesabilitado =
				"card-atividades__disabled" + cssPrimeiro + cssUltimo;

			element.disabledCss = cssDesabilitado;
		}
		
		this.state = {
			habilitado: enabled,
			dia: diaExibir,
			diaTextual: dataTextual,
			activities: sortedActivities,
		};
	}

	sortActivities = (activities, enabled, dia) => {
		let sortedActivities = [];

		activities.forEach((order) => {
			let act = activitiesConfig.find((a) => a.type === order.type);
			if (act) {
				act = this.prepareActivity(
					order,
					act.type,
					act.route,
					act.disabledIcon,
					act.enabledIcon,
					act.imageAlt,
					enabled,
					dia
				);
				sortedActivities.push(act);
			}
		});

		return sortedActivities;
	};

	prepareActivity = (
		element,
		name,
		route,
		disabledIcon,
		enabledIcon,
		imageAlt,
		enabled,
		dia
	) => {
		element.disabledIcon = disabledIcon;
		element.enabledIcon = enabledIcon;
		element.imageAlt = imageAlt;
		element.enabled = enabled;
		element.size = this.activitySize()
		element.navegar = () =>
			this.props.navegar(
				route,
				this.props.dia.scheduleCode,
				element.uuid,
				this.urlTrofeu(name)
			);
		element.key = dia + name;
		return element;
	};

	urlTrofeu = (tipo) => {
		let atividades = this.props.dia.activities;
		for (var i = 0; i < atividades.length; i++) {
			if (tipo === atividades[i].type) {
				return atividades[i].trophyEnabled;
			}
		}
	};

	 activityChunks = (activities, chunks) =>{
        let final = [];
        let n = activities.length;
        for( let i = 0; i < n; i += chunks) {
          final = [...final, activities.slice(i, i + chunks)];
        }
        return final;
      }

	activitySize = () => {
		let length = this.props.dia.activities.length;
		return { width: 100 / length + "%" };
	};

	daySize = () => {
		let length = this.props.dia.activities.length;
		return { width: 20.5 * length + "%" };
	};

	minSpanSize(){
        let length = this.props.dia.activities.length;
        if(!length || length < 4){
            let estilos = {display: 'flex', flexDirection: 'column'}
            if(length === 0){
                estilos.marginBottom = '1vh'
            }
            return estilos
        }else{
            return {}
        }
    }

	render() {
		let activitiesResults = this.activityChunks(this.state.activities, 5);
		let finalActivities = activitiesResults.map((items, key, index) => {			
			let finalWidth;
			if(items.length === 5) {
				finalWidth = 20
			} else if(items.length === 4){
				finalWidth = 21.2
			} else if(items.length === 1) {
				finalWidth = 21.5
			} else {
				finalWidth = 21
			}
			let finalSize = finalWidth * items.length + "%"
			return(
				<div
				key={key}
				style={{ width: finalSize}}
				className={`atividades-container atividades-dia ${
					this.state.habilitado ? "" : "atividades-dia__disabled"
				}`}
				>
					{
						items.map(function (el, index) {
							return (
								<AtividadeDia
									key={index}
									chave={index}
									navegar={el.navegar}
									habilitado={el.enabled}
									imagemHabilitado={el.enabledIcon}
									imagemDesabilitado={el.disabledIcon}
									cssDesabilitado={el.enabled ? "" : el.disabledCss}
									imagemAlt={el.imageAlt}
									executado={el.executed}
									size={{width: '55px'}}
									last={index + 1 === items.length}
								></AtividadeDia>
							);
						})
					}
				</div>
			)
		})

		return (
			<AnimateOnChange style={this.minSpanSize()} key={this.state.dia}>

				<div className="dia-agenda-container">
					<div className="card-dia">
						<span className="card-dia__diaSemana">
							{this.props.i18n.message("geral.diasemana." + this.props.dia.dayOfWeek, this.props.dia.dayOfWeek)}
						</span>{" "}
						<br />
						<span>{this.state.diaTextual}</span>
					</div>

					<div
					style={{width: "82%"}}
					>
						{finalActivities}
					</div>
					
				</div>
			</AnimateOnChange>
		);
	}
}

const mapStateToProps = function(state) {
    return {
        i18n:state.i18n
    }
}

export default connect(mapStateToProps)(DiaSemanaAgenda)